module.exports = __webpack_public_path__ + "static/media/banner-2.f103eec8.webp";